import {
  UPDATE_CLIPS,
  UPDATE_ALL_CLIPS,
  UPDATE_AUTO_CLIPS, CLEAR_AUTO_CLIPS,
} from '../mutationTypes';

export default {
  [UPDATE_CLIPS](state, {data} = {}) {
    if (data) {
      state.clips = data;
    }
  },
  [UPDATE_ALL_CLIPS](state, data = []) {
    state.allClips = data;
  },
  [UPDATE_AUTO_CLIPS](state, data = []) {
    state.autoClips = data;
  },
  [CLEAR_AUTO_CLIPS](state) {
    state.autoClips = [];
  },
};
